import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ShopProfileService } from '@services/shop-profile.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-reset-password-modal',
    templateUrl: './reset-password-modal.component.html',
    styleUrls: ['./reset-password-modal.component.less'],
})
export class ResetPasswordModalComponent implements OnInit {
    validateForm!: FormGroup;
    forgotEmail = true;
    submitting = false;
    isSuccess = false;
    code: string;

    constructor(
        public modalRef: NzModalRef,
        private fb: FormBuilder,
        private auth: AngularFireAuth,
        private message: NzMessageService,
        private profileService: ShopProfileService,
        private activatedRoute: ActivatedRoute
    ) {}

    confirmValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value) {
            return { error: true, required: true };
        } else if (control.value !== this.validateForm.controls.password.value) {
            return { confirm: true, error: true };
        }
        return {};
    };

    ngOnInit(): void {
        this.code = this.activatedRoute.snapshot.queryParamMap.get('oobCode');
        if (this.code) {
            this.validateForm = this.fb.group({
                password: ['', [Validators.required, Validators.minLength(8)]],
                confirmPassword: ['', [Validators.required, this.confirmValidator]],
            });
        } else {
            this.validateForm = this.fb.group({
                email: ['', [Validators.required, Validators.email]],
            });
        }
    }

    validateConfirmPassword(): void {
        Promise.resolve().then(() => this.validateForm.controls.confirmPassword.updateValueAndValidity());
    }

    goSignIn() {
        this.modalRef.triggerCancel();
        this.profileService.showSignInModal();
    }

    resetPassword() {
        this.submitting = true;
        if (!this.code) {
            this.auth
                .sendPasswordResetEmail(this.validateForm.get('email').value, {
                    handleCodeInApp: false,
                    url: `${window.location.origin}/main/home`,
                })
                .then(() => {
                    this.forgotEmail = false;
                    this.submitting = false;
                })
                .catch(e => {
                    this.submitting = false;
                    this.message.error('Sending failed, please try again.');
                });
        } else {
            if (this.validateForm.get('password').value !== this.validateForm.get('confirmPassword').value) {
                return;
            }

            this.auth
                .confirmPasswordReset(this.code, this.validateForm.get('password').value)
                .then(resp => {
                    this.isSuccess = true;
                    this.submitting = false;
                    setTimeout(() => {
                        this.goSignIn();
                    }, 3000);
                })
                .catch(e => {
                    this.submitting = false;
                    this.message.error('Reset password failed, please try again.');
                });
        }
    }
}
